(function ($) {
  var $highlights = $(".highlights");

  if ($highlights.length > 0) {
    $highlights.each(function () {
      var $wrap = $(this).find(".highlights__wrap");
      var slides = $wrap.find(".highlights__card");
      var slidesCount = slides.length;
      var totalSlidesToShow = (slidesCount > 4 && slidesCount < 8) ? 20 : Math.ceil(slidesCount / 4) * 4;

      // Initialize slick slider
      $wrap.slick({
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: true,
        dots: false,
        prevArrow: $(this).find(".cd-slick-prev .cd-slick-prev__btn"),
        nextArrow: $(this).find(".cd-slick-next .cd-slick-next__btn"),
        infinite: true,
        slidesToScroll: 4,
        slidesToShow: 4,
        speed: 0,
        responsive: [
          {
            breakpoint: 596,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });

      if (slidesCount > 4 && slidesCount < 8) {
        var slidesToClone = totalSlidesToShow - slidesCount;
        for (var i = 0; i < slidesToClone; i++) {
          var cloneIndex = (i % slidesCount);
          var clonedSlide = $(slides[cloneIndex]).clone(true, true);
          $wrap.slick("slickAdd", clonedSlide);
        }
      }
    });
  }
})(jQuery);
